import { RouteObject } from 'react-router';

import { ShopDetailsPage } from './pages/ShopDetailsPage';
import { ShopDetailsEditPage } from './pages/ShopDetailsEditPage';
import { SHOP_DETAIL_KEY } from './service/shop-details.interface';
import { CustomizationPage } from './pages/CustomizationPage';
import { StylesPages } from './pages/StylesPages';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { DocumentsPage } from './pages/DocumentsPage';

const routes: RouteObject[] = [
    {
        path: 'shop-details',
        element: <ShopDetailsPage />,
    },
];

export default routes;

export const extraRoutes: RouteObject[] = [
    {
        path: 'admin/shop-detail/:id',
        element: <ShopDetailsEditPage />,
        children: [
            {
                path: SHOP_DETAIL_KEY.CUSTOMIZATION,
                element: <CustomizationPage />,
            },
            {
                path: SHOP_DETAIL_KEY.STYLES,
                element: <StylesPages />,
            },
            {
                path: SHOP_DETAIL_KEY.ANALYTICS,
                element: <AnalyticsPage />,
            },
            {
                path: SHOP_DETAIL_KEY.DOCUMENTS,
                element: <DocumentsPage />,
            },
        ],
    },
];
